var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasViewPermission
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
              "show-print": false,
            },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "tile is-parent" }, [
                _c(
                  "article",
                  { staticClass: "tile is-child box" },
                  [
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "is-loading": _vm.isTableLoading,
                          "page-index": _vm.filter.pageIndex,
                          "page-size": _vm.filter.pageSize,
                          "sort-column": _vm.filter.sortColumn,
                          "sort-order": _vm.filter.sortOrder,
                          "total-rows": _vm.totalRows,
                        },
                        on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                      },
                      [
                        _vm._l(_vm.records, function (record, index) {
                          return _c("tr", { key: index }, [
                            _c("td", [_vm._v(_vm._s(record.email))]),
                            _c("td", [_vm._v(_vm._s(record.username))]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  record.requestAt
                                    ? _vm.$filters.formatDateTimeLocale(
                                        `${record.requestAt}Z`,
                                        _vm.$userInfo.locale
                                      )
                                    : ""
                                )
                              ),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  record.resetAt
                                    ? _vm.$filters.formatDateTimeLocale(
                                        `${record.resetAt}Z`,
                                        _vm.$userInfo.locale
                                      )
                                    : ""
                                )
                              ),
                            ]),
                          ])
                        }),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      )
    : _c("div", [_vm._m(0)])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "is-flex is-justify-content-center pt-5" },
      [
        _c("div", { staticClass: "notification is-danger is-flex is-size-4" }, [
          _vm._v(" You do not have permission to view this page. "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }